var map = {
	"./additional_town_center.png": 408,
	"./archery_range.png": 409,
	"./barracks.png": 410,
	"./blacksmith.png": 411,
	"./bombard_tower.png": 412,
	"./castle.png": 413,
	"./defense.png": 414,
	"./dock.png": 415,
	"./farm.png": 416,
	"./feitoria.png": 417,
	"./fish_trap.png": 418,
	"./fortified_wall.png": 419,
	"./gate.png": 420,
	"./guard_tower.png": 421,
	"./house.png": 422,
	"./keep.png": 423,
	"./krepost.png": 424,
	"./lumber_camp.png": 425,
	"./market.png": 426,
	"./mill.png": 427,
	"./mining_camp.png": 428,
	"./monastery.png": 429,
	"./outpost.png": 430,
	"./palisade_gate.png": 431,
	"./palisade_wall.png": 432,
	"./siege_workshop.png": 433,
	"./stable.png": 434,
	"./stone_wall.png": 435,
	"./town_center.png": 436,
	"./university.png": 437,
	"./watch_tower.png": 438,
	"./wonder.png": 439
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 407;